import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const leadDashboardApi = {
    getDashboardKpis: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/kpis",
            params,
        });
    },

    getStatusTrend: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/status-trend",
            params,
        });
    },

    getHierarchy: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/hierarchy",
            params,
        });
    },

    getFamilyPerformance: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/family-performance",
            params,
        });
    },

    getBrandPerformance: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/brand-performance",
            params,
        });
    },

    getReasonAnalysis: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/reason-analysis",
            params,
        });
    },

    getStoreRankings: (params = {}) => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/store-rankings",
            params,
        });
    },

    getDashboardFilters: () => {
        return request({
            method: HTTP_METHOD.GET,
            url: "lead/dashboard/filters",
        });
    },
};

export default leadDashboardApi;